import * as React from 'react';

import { SectionHeader } from '@/pages/unauthenticated/landing-page/components/shared/section.header';

import { Faq } from './types';

export const SupportFaqs = ({ faqs }: { faqs: Faq[] }) => {
  return (
    <section className="redesign-container py-12 md:py-24 grid gap-12 items-start grid-cols-1">
      <SectionHeader title="FAQs" description="Have a question?" />
      <dl className="flex flex-col">
        {faqs.map((faq) => (
          <div key={faq.id} className="lg:grid lg:grid-cols-12 border-b py-8">
            <dt className="text-base font-semibold leading-7 lg:col-span-5">
              {faq.question}
            </dt>
            <dd className="mt-4 lg:col-span-7 lg:mt-0">
              <p className="text-base leading-7">{faq.answer}</p>
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
};
